import React from "react";
import { Container } from "@mui/material";
import { IBlog } from "../IBlog";
import { BlogTextContent } from "./BlogTextContent/BlogTextContent";
import { BlogImageContent } from "./BlogImageContent/BlogImageContent";
import { BlogMarkdownContent } from "./BlogMarkdownContent/BlogMarkdownContent";

export const BlogContent = ({ blog }: { blog: IBlog }) => {
  return (
    <Container>
      {blog.content.map((contentItem, index) => {
        switch (contentItem.type) {
          case "text":
            return <BlogTextContent key={index} value={contentItem.value} />;
          case "image":
            return (
              <BlogImageContent
                key={index}
                value={contentItem.value}
                alt={contentItem.alt}
                copyright={contentItem.copyright}
                heading={contentItem.heading}
              />
            );
          case "markdown":
            return <BlogMarkdownContent key={index} value={contentItem.value} images={contentItem.images} />;
          default:
            return null;
        }
      })}
    </Container>
  );
};

